import React, { Fragment } from "react";
import { Footerdark, PageLayout } from "../../../Constant";
import RoleForm from "./RoleForm";

const RoleAdd = () => {
    return (
        <Fragment>
            <RoleForm mainTitle={Footerdark} title={Footerdark} parent={PageLayout} />         
        </Fragment>
    )
}
export default RoleAdd;